<div class="container">
  <nav class="navbar">
    <ul id="top-nav">
      <li
        class="dropdown"
        (mouseenter)="toggleUserDropdown()"
        (mouseleave)="closeUserDropdown()"
        [class.navactive]="selectedReportMenu.startsWith('/user/')"
      >
        <span>{{ constants.user }}</span>
        <ul class="dropdown-menu" *ngIf="isUserDropdownOpen">
          <li [class.active]="isUserRequestActive">
            <a (click)="onUserMenuClick('/user/request')">Manage P&A</a>
          </li>
          <li [class.active]="isUserOtherRequestActive">
            <a (click)="onUserMenuClick('/user/other-request')">Other's P&A</a>
          </li>
        </ul>
      </li>

      <li
        class="dropdown"
        (mouseenter)="toggleLeadBuyerDropdown()"
        (mouseleave)="closeLeadBuyerDropdown()"
        [class.navactive]="selectedReportMenu.startsWith('/lead-buyer/')"
      >
        <span>Lead Buyer</span>
        <ul class="dropdown-menu" *ngIf="isLeadBuyerDropdownOpen">
          <li [class.active]="isLeadBuyerRequestActive">
            <a (click)="onLeadBuyerMenuClick('/lead-buyer/request', $event)"
              >Manage Assign Buyer</a
            >
          </li>
          <li [class.active]="isLeadBuyerOtherRequestActive">
            <a
              (click)="
                onLeadBuyerMenuClick('/lead-buyer/other-request', $event)
              "
              >Other's P&A</a
            >
          </li>
        </ul>
      </li>

      <li
        class="dropdown"
        (mouseenter)="toggleBuyerDropdown()"
        (mouseleave)="closeBuyerDropdown()"
        [class.navactive]="selectedReportMenu.startsWith('/buyer/')"
      >
        <span>Buyer</span>
        <ul class="dropdown-menu" *ngIf="isBuyerDropdownOpen">
          <li [class.active]="isBuyerRequestActive">
            <a (click)="onBuyerMenuClick('/buyer/request', $event)"
              >Manage Information</a
            >
          </li>
          <li [class.active]="isBuyerOtherRequestActive">
            <a (click)="onBuyerMenuClick('/buyer/other-request', $event)"
              >Other's P&A</a
            >
          </li>
        </ul>
      </li>

      <li
        class="dropdown"
        (mouseenter)="toggleDelegationDropdown()"
        (mouseleave)="closeDelegationDropdown()"
        [class.navactive]="selectedReportMenu.startsWith('/delegation/')"
      >
        <span>Delegation</span>
        <ul class="dropdown-menu" *ngIf="isDelegationDropdownOpen">
          <li [class.active]="isManageDelegationActive">
            <a (click)="onDelegationMenuClick('/delegation/delegation-list')">{{
              constants.manageDelegation
            }}</a>
          </li>
        </ul>
      </li>
      <li
        class="dropdown"
        (mouseenter)="toggleReportDropdown()"
        (mouseleave)="closeReportDropdown()"
        [class.navactive]="selectedReportMenu.startsWith('/report/')"
      >
        <span>Report</span>
        <ul class="dropdown-menu" *ngIf="isReportDropdownOpen">
          <li [class.active]="isDetailsReportActive">
            <a (click)="onReportMenuClick('/report/report-sample')"
              >Details Report</a
            >
          </li>
          <li [class.active]="isCycleReportActive">
            <a (click)="onReportMenuClick('/report/report-cycle')"
              >Cycle Time Report</a
            >
          </li>
          <li [class.active]="isDescReportActive">
            <a (click)="onReportMenuClick('/report/report-item-detail')"
              >Description Report</a
            >
          </li>
        </ul>
      </li>
      <li
        class="dropdown"
        (mouseenter)="toggleAdminDropdown()"
        (mouseleave)="closeAdminDropdown()"
        [class.navactive]="selectedReportMenu.startsWith('/admin/')"
      >
        <span>Admin</span>
        <ul class="dropdown-menu" *ngIf="isAdminDropdownOpen">
          <li [class.active]="isAdminManageUserActive">
            <a (click)="onAdminMenuClick('/admin/manage-user', $event)"
              >Manage User</a
            >
          </li>
          <li [class.active]="isAdminRequestActive">
            <a (click)="onAdminMenuClick('/admin/manage-request', $event)"
              >Manage P&A</a
            >
          </li>
          <li [class.active]="isCompanyCodeActive">
            <a (click)="onAdminMenuClick('/admin/company-code', $event)"
              >Setup Company Code</a
            >
          </li>
          <li [class.active]="isPuchasingCodeActive">
            <a (click)="onAdminMenuClick('/admin/purchasing-code', $event)"
              >Setup Purchasing Office</a
            >
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</div>
<div>
  <div class="welcome-message">
    <span>Welcome: {{ fullName }}</span>
  </div>
</div>
